module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "calendar-month"
  }, [_vm._t("popup"), _vm._l((_vm.weeks), function(week, weekIndex) {
    return _c('div', {
      key: weekIndex,
      staticClass: "calendar-month__row"
    }, _vm._l((week), function(ref, dateIndex) {
      var prev = ref.prev;
      var day = ref.day;
      var date = ref.date;
      var active = ref.active;
      var types = ref.types;
      var isToday = ref.isToday;
      var next = ref.next;

      return _c('div', {
        key: (weekIndex + "-" + dateIndex),
        staticClass: "calendar-month__day",
        class: {
          'calendar-month__day_active': active, 'calendar-month__day_arrow': prev || next
        },
        on: {
          "click": function($event) {
            return _vm.openPopup(active, day)
          }
        }
      }, [(prev) ? _c('Navi', {
        attrs: {
          "prev": prev,
          "month": _vm.prevMonth
        },
        on: {
          "click": _vm.clickPrevMonth
        }
      }) : _vm._e(), (next) ? _c('Navi', {
        attrs: {
          "next": next,
          "month": _vm.nextMonth
        },
        on: {
          "click": _vm.clickNextMonth
        }
      }) : _vm._e(), (date) ? _c('div', {
        staticClass: "calendar-month__date",
        class: {
          'calendar-month__date_active': isToday
        },
        style: ({
          backgroundColor: isToday ? _vm.bgColorStyle : ''
        })
      }, [_vm._v(_vm._s(date))]) : _vm._e(), (date && active) ? _c('div', {
        staticClass: "calendar-month__icons"
      }, _vm._l((types), function(type) {
        return _c('Icon', {
          key: type,
          attrs: {
            "type": type,
            "size": "small"
          }
        })
      }), 1) : _vm._e()], 1)
    }), 0)
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28f3363a","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/remote-edu/calendar/components/calendar/components/month/CalendarMonth.vue
// module id = 2ef1f314334f39ea6649
// module chunks = 7